const createId = import.meta.env.APP_NETCORE_CREATE_ID;
const registerId = import.meta.env.APP_NETCORE_REGISTER_ID;
const debug = import.meta.env.APP_NETCORE_DEBUG;

let isLoaded = false;
let smartechPromise = null;

function loadSmartechScript() {
  if (isLoaded) return Promise.resolve(window.smartech);
  if (smartechPromise) return smartechPromise;

  smartechPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "//cdnt.netcoresmartech.com/smartechclient.js";
    script.async = true;
    script.onload = () => {
      isLoaded = true;
      resolve(window.smartech);
    };
    script.onerror = () => reject(new Error("Failed to load Smartech script"));
    document.head.appendChild(script);
  });

  return smartechPromise;
}

export function useSmartech() {
  const init = async () => {
    const smartech = await loadSmartechScript();
    smartech("create", createId);
    smartech("register", registerId);
    smartech("identify", "");
    smartech("debug", debug);
  };

  const dispatch = (eventName, payload) => {
    if (window.smartech) {
      window.smartech("dispatch", eventName, payload);
    }
  };

  return { init, dispatch };
}
